import {
    SingleJob, SingleCompany, JobLocation, JobLevel, JobCategory
} from "interfaces/api/apiInterfaces";

export interface JobTrackingProps {
    company_id: number;
    company_name: string;
    company_short_name: string;
    job_applied: boolean;
    job_categories: string[];
    job_favorited: boolean;
    job_id: number;
    job_level: string[];
    job_locations: string[];
    job_name: string;
    job_short_name: string;
    job_state: string;
    job_type: string;
    job_ats_name?: string;
    placement_position?: string | null;
    sp_tags?: { type: string; value: string; }[];
}

/**
 * getJobTrackingProps: Generate the tracking props for a single job.
 */
export const getJobTrackingProps = (job: SingleJob, company: SingleCompany): JobTrackingProps => ({
    company_id: job?.company_id,
    company_name: company?.name,
    company_short_name: company?.short_name,
    job_applied: false,
    job_categories: job?.categories?.filter((x) => x.value).map((category: JobCategory) => category.value) ?? [],
    job_favorited: false,
    job_id: job?.id,
    job_level: job?.levels?.filter((x) => x.value).map((level: JobLevel) => level?.value) ?? [],
    job_locations: job?.locations?.map((location: JobLocation) => location.value) ?? [],
    job_name: job?.name,
    job_short_name: job?.short_name,
    job_state: job?.state,
    job_type: job?.type,
    job_ats_name: job?.ats_info?.provider,
    placement_position: null,
});
